
import React, { useEffect, useState } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid, Paper, useMediaQuery, Button, FormHelperText } from '@mui/material';
import styled, { inputStyles } from '../../Utils/inputChanges';
import Titlebar from '../TitleBar';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { Panna } from '../TitleList';
import { errorStyles } from '../../Utils/table';
import { useDispatch, useSelector } from 'react-redux';
import { createPannaEntry } from '../../Store/PHPSlice/Panna';
import PannaTable from '../MasterTables/PannaTable/PannaTable';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { selectFirm } from '../Selectors/Master/ItemSelectors';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';


const PannaEntry = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        firmId: '',
        pana_size: '',
        userId: userdata?.ID
    });

    const dispatch = useDispatch();
    const [errors, setErrors] = useState({});
    const firmlist = useSelector(selectFirm);

    useEffect(() => {
        dispatch(fetchCompanyData());
    }, [dispatch])

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (value > 0 || value === '') {
            setFormData({
                ...formData,
                [name]: value
            });
        }
    };


    const handleSubmit = (event) => {
        event.preventDefault();
        // Validate department name
        // console.log(formData);
        if (!formData.pana_size.trim()) {
            setErrors({ pana_size: 'Panna Size is required' });
            return;
        }

        // if (!formData.firmId.trim()) {
        //     setErrors({ firmId: 'Firm is required' });
        //     return;
        // }

        dispatch(createPannaEntry(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                // toast.success("Panna Added");
                alert("Panna Added");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };




    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const dropdownFirm = [
        {
            label: 'Firm',
            id: 'firmId',
            options: firmlist?.data || [],
            value: formData.firmId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firmId', value: newValue ? newValue.ID : '' } }, 'firmId'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            errors: errors.firmId
        }
    ];

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;

        setFormData({
            ...formData,
            [dropdownType]: value
        });

    };

    return (
        <>
            <Titlebar data={Panna} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Panna Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>
                            <Grid container spacing={0.5}>

                                {/* {dropdownFirm?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        errors={drop.errors}
                                    />
                                ))
                                } */}

                                <Grid item xs={12} md={6} >
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='pana_size' >Panna Entry:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <TextField
                                                    id='pana_size'
                                                    name='pana_size'
                                                    value={formData.pana_size}
                                                    onChange={handleInputChange}
                                                    inputProps={{ style: styled.input }}
                                                    sx={inputStyles}
                                                />
                                                {errors.pana_size && <FormHelperText style={errorStyles}>{errors.pana_size}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>

                <PannaTable />
            </div>
        </>
    );
}

export default PannaEntry;
